import { render, staticRenderFns } from "./WangEditor.vue?vue&type=template&id=3894f45d"
import script from "./WangEditor.vue?vue&type=script&lang=js"
export * from "./WangEditor.vue?vue&type=script&lang=js"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./WangEditor.vue?vue&type=style&index=1&id=3894f45d&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports